import Vue from 'vue'
import Vuetify from 'vuetify/lib'

Vue.use(Vuetify)

export default new Vuetify({
  theme: {
    themes: {
      light: {
        customPrimaryButtonColor: '#ffb20f',
        white: '#FFFFFF',
        lightgrey: '#f8f8f8'
      }
    },
    options: {
      addBookmarkColor: true // Enable custom properties for dynamic style updates
    }
  }
})
